module.exports = __webpack_public_path__ + "static/fonts/fa-solid-900.adec7d6f.ttf";